<template>
    <div class="d-flex flex-column image">

        <img class="img_initial contain align-self-center mt-7" src="../../assets/logo-lateral.png" alt="">

        <v-card class="ml-auto mr-auto" max-width='95%' width='500px'>

            <v-app-bar color="primary" flat dense dark>
                <v-toolbar-title class="body-1">{{$t('motive')}}</v-toolbar-title>
            </v-app-bar>

            <v-container fluid>
                <v-row>
                    <v-col>

                        <v-radio-group class="mb-n2" v-model="options" column>
                            <v-radio class="body-1" :label="$t('prospect_cancel.option_giveup')" value="Give up"></v-radio>
                            <v-radio class="body-1" :label="$t('prospect_cancel.option_many')" value="Lot emails"></v-radio>
                            <v-radio class="body-1" :label="$t('prospect_cancel.option_contract')" value="Contracted provider"></v-radio>
                            <v-radio class="body-1" :label="$t('prospect_cancel.option_other')" value="Other"></v-radio>
                        </v-radio-group>

                        <v-text-field v-if='options === "Contracted provider"' v-model="provider" :label="$t('provider')"></v-text-field>
                        <v-text-field v-if='options === "Other"' v-model="motive" :label="$t('motive')"></v-text-field>

                        <v-card-actions class="d-flex justify-center align-center">
                            <v-btn class="mb-n2" @click="unregister" color='error' :loading="loading" :disabled="disabled">{{$t('prospect_cancel.cancel_inscription')}}</v-btn>
                        </v-card-actions>

                    </v-col>
                </v-row>
            </v-container>

        </v-card>

    </div>
</template>

<script>
import { mapActions } from 'vuex' 

import { CANCEL_PROSPECTS } from '../../store/mutations'

export default {

    name: 'CancelEmail',

    data() {
        return {
            options: null,
            provider: null,
            motive: null,
            loader: null,
            loading: false,

        }
    },

    computed: {
        disabled() {

            if (this.loading) return true
            if (this.options === 'Contracted provider') return this.provider ? false: true
            if (this.options === 'Other') return this.motive ? false: true
            if (this.options) return false
            return true

        }
    },

    methods: {

        ...mapActions({ unregisterId: `ProspectVuex/${CANCEL_PROSPECTS}` }),

        async unregister() {

                this.loading = true;

                const data = { id: this.$route.params.id, reason: this.options };

                if (this.options === 'Contracted provider' && this.provider) data.contracted_provider = this.provider;
                if (this.options === 'Other' && this.motive) data.other_motive = this.motive;

                try {

                    await this.unregisterId(data);

                    this.$router.push('/prospect-location')

                    return this.showToast(this.$t('prospect_cancel.toast_success_msg'), this.$t('prospect_cancel.toast_success_title'), 'success')
                    
                } catch (error) {

                        console.log(error);

                        this.showToast(this.$t('prospect_cancel.toast_error_msg'), this.$t('prospect_cancel.toast_error_title'), 'error')
                    
                } finally {

                        this.loading = false;

                }

        }

    },

}
</script>

<style scoped>

.img_initial {

    height: 100px;

}

.image {

    width: 100%;
    height: 100%;
    
}



</style>